import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';

const AIFloatingButton = () => {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate('/ai-insights')}
      className="fixed bottom-6 right-6 w-16 h-16 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full shadow-2xl hover:scale-105 transition-all duration-300 flex items-center justify-center z-50 animate-fade-in"
      aria-label="Abrir Assistente IA"
    >
      <Icon name="Sparkles" size={28} color="#fff" />
    </button>
  );
};

export default AIFloatingButton;